interface Props {
	open: boolean;
}

function DownIcon({ open }: Props) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="6 0 24 24"
			strokeWidth={2}
			stroke="currentColor"
			className={`${open ? 'rotate-90' : ''} h-5 w-5 transition-transform`}
		>
			<path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5l7.5-7.5-7.5-7.5" />
		</svg>
	);
}

export default DownIcon;